export { default as reducer } from './reducer';
export { STATE_NAME } from './constants';
export { default as Variant } from './components/Variant';
export { default as Experiment } from './components/Experiment';
export { initExperiments, setVariants } from './actions';

export type ExperimentType = import('./utils/getSelectedVariant').Experiment;
